import React, { useEffect, useState } from 'react';
import {
  BookOutline,
  HelpCircleOutline,
  InformationCircleOutline,
  LockClosedOutline,
  LogOutOutline,
} from 'react-ionicons';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { setLoginStatus } from '../../../store/features/adminSlice';
import { DropDownMenu } from '../../Menu/MenuComponents';
import {
  DropdownBoxText,
  DropdownBoxTextContainer,
} from './DropdownComponents';

const Dropdown = ({ show = false, toggler }) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [isAdmin, setisAdmin] = useState(false);
  const isLoggedIn = useSelector((state) => state.admin.isLoggedIn);

  useEffect(() => {
    isLoggedIn ? setisAdmin(true) : setisAdmin(false);
  }, [isLoggedIn, location]);

  const logOut = () => {
    dispatch(setLoginStatus(false));
    history.push('/inicio');
  };

  return (
    <DropDownMenu
      style={{
        display: show ? 'block' : 'none',
        height: isAdmin ? '190px' : '',
      }}>
      <DropdownBoxTextContainer style={{ alignSelf: 'center' }}>
        <DropdownBoxText
          style={{ margin: 'auto', marginLeft: '-2px' }}
          to={'/terminos-de-uso'}>
          <InformationCircleOutline
            style={{
              paddingBottom: '1px',
              paddingLeft: '2px',
              paddingRight: '7px',
              display: 'block',
            }}
            width="16px"
            height="16px"
            color={'#003876'}
          />
          <div
            onClick={() => toggler()}
            style={{
              userSelect: 'none',
              color: '#003876',
              fontSize: '0.7rem',
              textDecoration: 'none',
              paddingRight: '31px',
            }}>
            Términos de uso
          </div>
        </DropdownBoxText>
        <DropdownBoxText
          style={{ margin: 'auto' }}
          to={'/politicas-de-privacidad'}>
          <LockClosedOutline
            style={{
              paddingBottom: '1px',
              paddingRight: '7px',
              display: 'block',
            }}
            width="16px"
            height="16px"
            color={'#003876'}
          />
          <div
            onClick={() => toggler()}
            style={{
              userSelect: 'none',
              color: '#003876',
              fontSize: '0.72rem',
              textDecoration: 'none',
            }}>
            Políticas de privacidad
          </div>
        </DropdownBoxText>
        <DropdownBoxText
          style={{ margin: 'auto', paddingLeft: '2px' }}
          to={'/acerca-de-aplicacion'}>
          <HelpCircleOutline
            style={{
              paddingBottom: '1px',
              paddingRight: '7px',
              marginLeft: '-1px',
              display: 'block',
            }}
            width="16px"
            height="16px"
            color={'#003876'}
          />
          <div
            onClick={() => toggler()}
            style={{
              color: '#003876',
              userSelect: 'none',
              fontSize: '0.72rem',
              textDecoration: 'none',
            }}>
            Acerca de la aplicación
          </div>
        </DropdownBoxText>

        {isAdmin ? (
          <>
            <DropdownBoxText
              to={'/manual'}
              style={{
                margin: 'auto',
                marginLeft: '2px',
                justifyContent: 'flex-start',
              }}>
              <BookOutline
                style={{
                  paddingRight: '7px',
                  marginRight: 'auto',
                  paddingTop: '3px',
                  display: 'inline-block',
                  verticalAlign: 'center',
                }}
                width="16px"
                height="16px"
                color={'#003876'}
              />
              <div
                style={{
                  userSelect: 'none',
                  color: '#003876',
                  fontSize: '0.72rem',
                  textDecoration: 'none',
                }}>
                Manual de usuario
              </div>
            </DropdownBoxText>
            <DropdownBoxText
              onClick={logOut}
              style={{
                margin: 'auto',
                marginLeft: '4px',
                justifyContent: 'flex-start',
              }}>
              <LogOutOutline
                style={{
                  paddingBottom: '1px',
                  paddingRight: '7px',
                  display: 'block',
                }}
                width="16px"
                height="16px"
                color={'#003876'}
              />
              <div
                style={{
                  userSelect: 'none',
                  color: '#003876',
                  fontSize: '0.72rem',
                  textDecoration: 'none',
                }}>
                Cerrar sesión
              </div>
            </DropdownBoxText>
          </>
        ) : null}
      </DropdownBoxTextContainer>
    </DropDownMenu>
  );
};

export default Dropdown;
